// src/pages/pengamatan/buah-alami/hooks/useSearch.js
import { useState, useCallback } from "react";

export const useSearch = (initialData = []) => {
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredData, setFilteredData] = useState(initialData);

    // Fungsi untuk mencari data berdasarkan lokasi - SEDERHANA
    const handleSearch = useCallback((term, data) => {
        setSearchTerm(term);
        if (term === "") {
            setFilteredData(data);
        } else {
            const filtered = data.filter((order) =>
                order.lokasi && order.lokasi.toLowerCase().includes(term.toLowerCase())
            );
            setFilteredData(filtered);
        }
    }, []);

    // Fungsi untuk mereset filter pencarian
    const handleResetFilter = useCallback((data) => {
        setSearchTerm("");
        setFilteredData(data);
    }, []);

    // Update data ketika data sumber berubah
    const updateData = useCallback((newData) => {
        setFilteredData(newData);
        // Jika ada search term, apply filter ke data baru
        if (searchTerm) {
            const filtered = newData.filter((order) =>
                order.lokasi && order.lokasi.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setFilteredData(filtered);
        }
    }, [searchTerm]);

    return {
        searchTerm,
        setSearchTerm,
        filteredData,
        setFilteredData,
        handleSearch,
        handleResetFilter,
        updateData
    };
};

export default useSearch;